<div class="header">
    <h2>Byggestatus</h2>
    <h2>Salgstatus</h2>
</div>
<div class="container">
    <div class="section">
        <ul>
            <li class="check-box all" (click)="selectAllBuildStatus()">
                <div class="checkbox-icon" [class.selected]="allSelectedBuildStatus()"></div>
                <label>Alle</label>
            </li>
            @for (option of filterFormBuildStatus(); track $index) {
            <li class="check-box" (click)="toggleSelectedBuildStatus(option().value())">
                <div class="checkbox-icon" [class.selected]="option.selected().value()"></div>
                <label> {{ option.label().value() }} </label>
            </li>
            }
        </ul>
    </div>
    <div class="section">
        <ul>
            <li class="check-box all" (click)="selectAllSaleStatus()">
                <div class="checkbox-icon" [class.selected]="allSelectedSaleStatus()"></div>
                <label>Alle</label>
            </li>
            @for (option of filterFormSaleStatus(); track option().value().value) {
            <li class="check-box" (click)="toggleSelectedSaleStatus(option().value())">
                <div class="checkbox-icon" [class.selected]="option.selected().value()"></div>
                <label> {{ option.label().value() }} </label>
            </li>
            }
        </ul>
    </div>
</div>